import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PayloadService } from '../../services/payload.service';

@Component({
  selector: 'app-stamperia',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './stamperia.component.html',
  styleUrl: './stamperia.component.scss',
})
export class StamperiaComponent implements OnInit {
  codiceBuono: string = '';
  email: string = '';
  isLoading: boolean = false;
  message: string = '';
  isError: boolean = false;
  isSuccess: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private payloadService: PayloadService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.codiceBuono = params['buono'] || '';
    });
  }

  onSubmit(): void {
    if (!this.email || !this.codiceBuono) {
      this.showError('Inserisci un indirizzo email valido');
      return;
    }

    this.isLoading = true;
    this.message = '';
    this.isError = false;
    this.isSuccess = false;

    this.payloadService.generateCoupon(this.email, this.codiceBuono).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.isSuccess = true;
        if (response.isResend) {
          this.message = 'Il tuo coupon è stato re-inviato alla tua email!';
        } else {
          this.message = 'Coupon generato con successo! Controlla la tua email.';
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.showError(error.error?.error || 'Si è verificato un errore. Riprova più tardi.');
      },
    });
  }

  private showError(msg: string): void {
    this.isError = true;
    this.isSuccess = false;
    this.message = msg;
  }
}
